/* eslint-disable react/prop-types */
import { useNavigate } from 'react-router-dom';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Button } from '../common';

/**
 * 返回按钮
 * @param {Object} option 参数
 * @param {() => void} option.onClickBack 点击返回跳转之前的事件
 */
export const BackButton = ({ onClickBack, backStep }) => {
  const navigate = useNavigate();

  const onClick = () => {
    onClickBack?.();
    navigate(backStep || -1);
  };

  return (
    <Button
      variant="outlined"
      startIcon={<ArrowBackRoundedIcon />}
      style={{
        border: '1px solid #BABFC3',
        borderRadius: '2px',
        color: '#202223',
        padding: '8px 16px',
        boxShadow: '0px 1px 0px rgba(0, 0, 0, 0.05)',
      }}
      sx={{
        backgroundColor: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#F6F6F7',
        },
      }}
      onClick={onClick}
    >
      Back
    </Button>
  );
};
